import { CreateElement, Scale } from "../MyHelpers";
import { DecodedImageResource, ImageResource } from "../ResourceManager/ImageResource";
import { Resourceful } from "../ResourceManager/Resourceful";
import { ResourceIdentifier } from "../ResourceManager/ResourceIdentifier";
import { IReadOnlyResourceManager, IWriteOnlyResourceManager, ResourceManager } from "../ResourceManager/ResourceManager";
import { ZIndex } from "../ZIndex";
import { TweenLite } from "gsap";
import { service } from "../services";
import { Translator } from "../Translator";
import * as PIXI from 'pixi.js';
import { GameViewAppPixi } from "../engine/gameViewAppPixi";
import { Settings } from "../Settings";
import { AudioManager, Track } from "../AudioManager";
import { IContext } from "../Context/IContext";
import { ISystemContext, SystemContext } from "../Context/SystemContext";
import { ITimeout } from "../Context/Timeout";
import { Money } from "../api";
import { FixedSizeFitContainer, ResponsiveSizeContainer, ResponsiveView } from "../../singlegame/ResponsiveHelpers";

export type OnConfirmBetTypeChangePress = () => void;
export type OnCancelBetTypeChangePress = () => void;
export class BuyBonusMenu implements Resourceful {

    protected resid: ResourceIdentifier;
    protected basePathGame: string;
    protected app: PIXI.Application<HTMLCanvasElement> = null;
    protected onConfirmBetTypeChangePress: OnConfirmBetTypeChangePress = null;
    protected onCancelBetTypeChangePress: OnCancelBetTypeChangePress = null;
    protected isLocked: boolean = false;
    protected translator: Translator;
    protected buyBonusValueString: string = "";
    protected gameBetString: string = "";
    protected audio : AudioManager = null;
    protected readonly context: ISystemContext;
    protected readonly acceptDelay: ITimeout;

    constructor(resid: ResourceIdentifier, context: ISystemContext, basePath: string, translator: Translator , audio : AudioManager) {
        this.resid = resid.Add("BuyBonusMenu");
        this.context = context.CreateSubContext("BuyBonusMenu");
        this.acceptDelay = this.context.TimingContext().CreateTimeout("acceptDelay", 1000, () => {
            this.ButtonAcceptDelayed();
        });

        // this.view = CreateElement("div", {
        //     classes: [this.resid.Scope()],
        //     style: {
        //         position: "absolute",
        //         pointerEvents: "all",
        //         width: "100%",
        //         height: "100%",
        //         top: "0px",
        //         left: "0px",
        //         display: "flex",
        //         flexDirection: "column",

        //         backgroundColor: "rgba(0,0,0,0.7)",
        //         fontFamily: "NotoSansDisplay-Bold",
        //         zIndex: ZIndex.BetTypeMenu.toString(),
        //         justifyContent: "center",
        //         alignItems: "center",
        //     }
        // });
        this.basePathGame = basePath;
        this.translator = translator;
        this.audio = audio;
    }

    protected balanceCents: number = 0;
    protected betCents: number = 0;
    public UpdateBalance(balanceCents: number): void
    {
        this.balanceCents = balanceCents;

        this.UpdateDisplay();
    }

    public UpdateBet(betCents: number): void
    {
        this.betCents = betCents;

        this.UpdateDisplay();
    }

    enabled: boolean = true;
    public Enabled(enabled: boolean): void
    {
        this.enabled = enabled;
    }

    CanBet(): boolean
    {
        if (this.balanceCents < 1)
        {
            return false;
        }

        if (this.balanceCents < this.betCents)
        {
            return false;
        }

        return true;
    }

    protected UpdateDisplay()
    {
        if (!this.visible)
        {
            return;
        }

        if (this.CanBet())
        {
            this.buttonAcceptContainerApp.interactive = true;
            this.buttonAcceptContainerApp.filters = [];
            this.buttonAcceptContainerApp.alpha = 1;
        }
        else
        {
            const grayscaleFilter = new PIXI.filters.ColorMatrixFilter();
            grayscaleFilter.greyscale(1, false);
            
            this.buttonAcceptContainerApp.interactive = false;
            this.buttonAcceptContainerApp.filters = [grayscaleFilter];
            this.buttonAcceptContainerApp.alpha = 0.7;
        }
    }

    public ButtonAcceptDelayed(): void
    {
        this.onConfirmBetTypeChangePress();
        this.Hide();
    }

    public ButtonAccept(): void
    {
        if (this.acceptDelay.Running())
        {
            // already running, don't accept it again
            return;
        }

        if (!this.CanBet())
        {
            return;
        }

        this.audio.Track(this.resid.ScopedResourceName("cashInBuyBonus")).Play(false);  
        this.acceptDelay.Start();        
    }

    public ButtonCancel()
    {
        if (this.acceptDelay.Running())
        {
            // already running, don't cancel it
            return;
        }

        this.onCancelBetTypeChangePress();
    }

    public Create(app: PIXI.Application<HTMLCanvasElement>) {
        this.app = app;
        // this.app.stage.addChild(this.buyBonusContainer);
    }

    public Destroy() {
        this.buyBonusContainer.destroy();
    }

    protected buyBonusContainer: PIXI.Container = null;
    protected confirmButtonBonus: PIXI.Texture<PIXI.Resource>;
    protected cancelButtonBonus: PIXI.Texture<PIXI.Resource>;
    protected textureButtonBonusStart: PIXI.Texture<PIXI.Resource>;
    protected textureButtonBonusEnd: PIXI.Texture<PIXI.Resource>;
    protected infoTextStyle: PIXI.TextStyle = null;
    protected textButtonsStyle: PIXI.TextStyle = null;
    //protected textStyle2: PIXI.TextStyle = null;
    protected startTextView: PIXI.Text = null;
    protected priceTextView: PIXI.Text = null;
    protected textureDialogBonus: PIXI.Texture<PIXI.Resource>;

    public ResourcesLoaded(resourceManager: IReadOnlyResourceManager) {

        let buttonTexturesDecodedStart = resourceManager.Get<DecodedImageResource>(ResourceIdentifier.Global.ScopedResourceName("startButton-BuyBonus"));
        //buttonTextureBasePixi.scaleMode = PIXI.SCALE_MODES.NEAREST;
        this.textureButtonBonusStart = PIXI.Texture.from(buttonTexturesDecodedStart.DecodedImage());

        let buttonTexturesDecodedEnd = resourceManager.Get<DecodedImageResource>(ResourceIdentifier.Global.ScopedResourceName("exitButton-BuyBonus"));
        //buttonTextureBasePixi.scaleMode = PIXI.SCALE_MODES.NEAREST;
        this.textureButtonBonusEnd = PIXI.Texture.from(buttonTexturesDecodedEnd.DecodedImage());

        let dialogTexturesDecoded = resourceManager.Get<DecodedImageResource>(ResourceIdentifier.Global.ScopedResourceName("FrameBuyBonus-Frame"));
        //dialogTextureBasePixi.scaleMode = PIXI.SCALE_MODES.NEAREST;
        this.textureDialogBonus = PIXI.Texture.from(dialogTexturesDecoded.DecodedImage());

    }

    buttonAcceptContainerApp: PIXI.Container;

    public CreatePIXIAPP() {

        this.buyBonusContainer = new PIXI.Container();
        //this.buyBonusContainer.width = Scale.W(1920);
        //this.buyBonusContainer.height = Scale.H(1080);
        //this.buyBonusContainer.pivot.set(Scale.W(1152) / 2, Scale.H(648) / 2);
        //this.buyBonusContainer.x = Scale.W(1920) / 2;
        this.buyBonusContainer.y = (Settings.ScreenHeight) * (Settings.Screens - 1);
        this.buyBonusContainer.name = "buyBonusContainer";

      
        let backgroundPanel = new PIXI.Sprite(PIXI.Texture.WHITE);
        backgroundPanel.width = Scale.W(1920);
        backgroundPanel.height = Scale.W(1080);
        backgroundPanel.tint = "0x000000";
        backgroundPanel.alpha = 0.74;        
        this.buyBonusContainer.addChild(backgroundPanel);

        let spriteintroSpanishMessageContainerApp = PIXI.Sprite.from(this.textureDialogBonus);
        //spriteintroSpanishMessageContainerApp.scale.set(Scale.XY(1));
        //spriteintroSpanishMessageContainerApp.pivot.set(spriteintroSpanishMessageContainerApp.width /2 , spriteintroSpanishMessageContainerApp.height/2);  
        spriteintroSpanishMessageContainerApp.position.set(Scale.W(1920 / 2) - (spriteintroSpanishMessageContainerApp.width / 2) , 0);      
        //spriteintroSpanishMessageContainerApp.width = Scale.W(1152);
        //spriteintroSpanishMessageContainerApp.height = Scale.H(648);
        //spriteintroSpanishMessageContainerApp.tint = "0x000000";
        this.buyBonusContainer.addChild(spriteintroSpanishMessageContainerApp);

        //Create title 
        let textStyleRedTitle = new PIXI.TextStyle({
            fontFamily: 'NotoSansDisplay-Bold',
            fontSize: Scale.fh(160),
            fontWeight: 'bold',
            fill: ["red"],
            stroke: 'black',
            strokeThickness: Scale.fh(5),
            wordWrap: false,
            padding: 10,
            textBaseline: "middle",
            align: "center"
        });

        let textTitleBuyBonus = new PIXI.Text(`!${this.translator.t.buyBonusTitle}!`,textStyleRedTitle);
        this.buyBonusContainer.addChild(textTitleBuyBonus);
        textTitleBuyBonus.pivot.set(textTitleBuyBonus.width / 2 , textTitleBuyBonus.height / 2);
        textTitleBuyBonus.position.set(Scale.X(1920 / 2 ) , Scale.Y(100));
        //Finished

        this.infoTextStyle = new PIXI.TextStyle({
            fontFamily: 'NotoSansDisplay-Bold',
            fontSize: Scale.fh(80),
            fontWeight: 'bold',
            fill: "white",
            stroke: 'black',
            strokeThickness: Scale.fh(5),
            wordWrap: false,
            padding: 10,
            textBaseline: "middle",
            align: "center",
            lineJoin : "round",
        });

        this.textButtonsStyle = new PIXI.TextStyle({
            fontFamily: 'NotoSansDisplay-Bold',
            fontSize: Scale.fh(70),
            fontWeight: 'bold',
            fill: "white", // red
            stroke: 'black',
            strokeThickness: Scale.fh(5),
            wordWrap: false,
            padding: 10,
            textBaseline: "alphabetic",
            lineJoin : "round",
        });

        // this.textStyle2 = new PIXI.TextStyle({
        //     fontFamily: 'NotoSansDisplay-Bold',
        //     fontSize: Scale.fh(70),
        //     fontWeight: 'bold',
        //     fill: "white", // green
        //     stroke: 'black',
        //     strokeThickness: Scale.fh(5),
        //     wordWrap: false,
        //     padding: 10,
        //     textBaseline: "alphabetic"
        // });

        this.startTextView = new PIXI.Text(this.translator.t.buyStickyBonus + this.gameBetString, this.infoTextStyle);
        this.startTextView.anchor.set(0.5);
        this.startTextView.x = this.buyBonusContainer.width / 2;
        this.startTextView.y = this.buyBonusContainer.height / 4 + Scale.fh(20);

        this.priceTextView = new PIXI.Text(this.buyBonusValueString, this.infoTextStyle);
        this.priceTextView.anchor.set(0.5);
        this.priceTextView.x = this.buyBonusContainer.width / 2;
        this.priceTextView.y = this.startTextView.y + Scale.fh(100);

        //Create buttons 
        let buttonWidth = Scale.W(400);
        let buttonHeight = Scale.H(200);

        this.buttonAcceptContainerApp = new PIXI.Container();
        this.buttonAcceptContainerApp.name = "buttonAcceptContainerApp";
        this.buttonAcceptContainerApp.width = buttonWidth;
        this.buttonAcceptContainerApp.height = buttonHeight;
        this.buttonAcceptContainerApp.pivot.set(buttonWidth / 2, buttonHeight / 2);
        this.buttonAcceptContainerApp.x = this.buyBonusContainer.width / 2 + Scale.W(250);
        this.buttonAcceptContainerApp.y = this.priceTextView.y + Scale.H(350); // Positioned below price text
        this.buttonAcceptContainerApp.interactive = true;
        this.buyBonusContainer.addChild(this.buttonAcceptContainerApp);

        let buttonCancelContainerApp = new PIXI.Container();
        buttonCancelContainerApp.name = "buttonCancelContainerApp";
        buttonCancelContainerApp.width = buttonWidth;
        buttonCancelContainerApp.height = buttonHeight;
        buttonCancelContainerApp.pivot.set(buttonWidth / 2, buttonHeight / 2);
        buttonCancelContainerApp.x = this.buyBonusContainer.width / 2 - Scale.W(250);
        buttonCancelContainerApp.y = this.priceTextView.y + Scale.H(350); // Positioned below price text
        buttonCancelContainerApp.interactive = true;
        this.buyBonusContainer.addChild(buttonCancelContainerApp);

        let spriteButtonAcceptContainerApp = PIXI.Sprite.from(this.textureButtonBonusStart);
        spriteButtonAcceptContainerApp.width = buttonWidth;
        spriteButtonAcceptContainerApp.height = buttonHeight;
        spriteButtonAcceptContainerApp.anchor.set(0.5);
        spriteButtonAcceptContainerApp.x = buttonWidth / 2;
        spriteButtonAcceptContainerApp.y = buttonHeight / 2;
        spriteButtonAcceptContainerApp.interactive = true;

        let confirmTextView = new PIXI.Text(this.translator.t.buttonMenuAccept, this.textButtonsStyle);
        confirmTextView.anchor.set(0.5);
        confirmTextView.x = 0;
        confirmTextView.y = 0;

        spriteButtonAcceptContainerApp.addChild(confirmTextView);
        this.buttonAcceptContainerApp.addChild(spriteButtonAcceptContainerApp);

        let spriteButtonCancelContainerApp = PIXI.Sprite.from(this.textureButtonBonusEnd);
        spriteButtonCancelContainerApp.width = buttonWidth;
        spriteButtonCancelContainerApp.height = buttonHeight;
        spriteButtonCancelContainerApp.anchor.set(0.5);
        spriteButtonCancelContainerApp.x = buttonWidth / 2;
        spriteButtonCancelContainerApp.y = buttonHeight / 2;

        let cancelTextView = new PIXI.Text(this.translator.t.buttonMenuCancel, this.textButtonsStyle);
        cancelTextView.anchor.set(0.5);
        cancelTextView.x = 0;
        cancelTextView.y = 0;

        spriteButtonCancelContainerApp.addChild(cancelTextView);
        buttonCancelContainerApp.addChild(spriteButtonCancelContainerApp);

        this.buttonAcceptContainerApp.addListener("pointerdown", (ev: MouseEvent) => {           
            this.ButtonAccept();
        });

        buttonCancelContainerApp.addListener("pointerdown", (ev: MouseEvent) => {
            this.ButtonCancel();
        });

        this.buyBonusContainer.visible = false;
        this.visible = false;
        //End buttons


        //MESSAGE CONFIRM 
        let textStyleRedMessage = new PIXI.TextStyle({
            fontFamily: 'NotoSansDisplay-Bold',
            fontSize: Scale.fh(50),
            fontWeight: 'bold',
            fill: ["red"],
            stroke: 'black',
            strokeThickness: Scale.fh(5),
            wordWrap: false,
            padding: 10,
            textBaseline: "middle",
            align: "center",
            lineJoin : "round",
        });

        let textTitleBuyBonusConfirmMessage = new PIXI.Text(this.translator.t.buyStickyBonusConfirmMessage, textStyleRedMessage);
        this.buyBonusContainer.addChild(textTitleBuyBonusConfirmMessage);
        textTitleBuyBonusConfirmMessage.anchor.set(0.5)
        //textTitleBuyBonusConfirmMessage.pivot.set(textTitleBuyBonusConfirmMessage.width / 2, textTitleBuyBonusConfirmMessage.height / 2);
        textTitleBuyBonusConfirmMessage.position.set(Scale.X(1920 / 2), Scale.Y(466.5));
        

        let textStyleRedMessage2 = new PIXI.TextStyle({
            fontFamily: 'NotoSansDisplay-Bold',
            fontSize: Scale.fh(30),
            fontWeight: 'bold',
            fill: ["white"],
            stroke: 'black',
            strokeThickness: Scale.fh(5),
            wordWrap: true,
            padding: 10,
            textBaseline: "middle",
            align: "center",
            wordWrapWidth : Scale.W(1220),
            lineJoin : "round",
        });

        let textTitleBuyBonusConfirmMessage2 = new PIXI.Text(this.translator.t.buyStickyBonusConfirmMessage2, textStyleRedMessage2);
        this.buyBonusContainer.addChild(textTitleBuyBonusConfirmMessage2);
        textTitleBuyBonusConfirmMessage2.anchor.set(0.5);
        textTitleBuyBonusConfirmMessage2.position.set(Scale.X(1920 / 2), Scale.Y(547.5));
        this.translator.SetOnLanguageChangedCallback(()=>{
            textTitleBuyBonusConfirmMessage2.text = this.translator.t.buyStickyBonusConfirmMessage2;
            textTitleBuyBonusConfirmMessage.text = this.translator.t.buyStickyBonusConfirmMessage;
            textTitleBuyBonus.text = `!${this.translator.t.buyBonusTitle}!`
            //textTitleBuyBonusConfirmMessage?.pivot.set(textTitleBuyBonusConfirmMessage.width / 2, textTitleBuyBonusConfirmMessage.height / 2);
            //textTitleBuyBonusConfirmMessage?.position.set(Scale.X(1920 / 2), Scale.Y(466.5));
        });
        //END MESSAGE
    }


    public PrepareResources(resourceManager: IWriteOnlyResourceManager) {
        //resourceManager.Add(new DecodedImageResource(this.basePathGame + "resources/button.png", this.resid.ScopedResourceName(["button", "image"])));
        //resourceManager.Add(new DecodedImageResource(this.basePathGame + "resources/dialog.png", this.resid.ScopedResourceName(["dialog", "image"])));        
        resourceManager.AddGlobal(new DecodedImageResource(Settings.ResourcesFolder + "multigame/slot/common/resources/BuyBonus/frameBuyBonus.png", ResourceIdentifier.Global.ScopedResourceName("FrameBuyBonus-Frame")));
        resourceManager.AddGlobal(new DecodedImageResource(Settings.ResourcesFolder + "multigame/slot/common/resources/BuyBonus/start.png", ResourceIdentifier.Global.ScopedResourceName("startButton-BuyBonus")));
        resourceManager.AddGlobal(new DecodedImageResource(Settings.ResourcesFolder + "multigame/slot/common/resources/BuyBonus/exit.png", ResourceIdentifier.Global.ScopedResourceName("exitButton-BuyBonus")));
        this.audio.AddTrack(new Track(Settings.ResourcesFolder + "multigame/slot/common/resources/BuyBonus/tracks/cashInBuyBonus"+Settings.audioFormat, this.resid.ScopedResourceName("cashInBuyBonus"), false));
    }


    public ViewPIXIAPP(): PIXI.Container {
        return this.buyBonusContainer;
    }

    protected visible: boolean = false;
    public Visible(): boolean {
        return this.visible;
    }

    public Show() {
        if (this.visible) return;
        if (!this.enabled) return;

        this.visible = true;
        this.UpdateDisplay();

        console.log("Show func.");

        this.buyBonusContainer.visible = true;
        this.buyBonusContainer.interactiveChildren = true;
    }

    public Hide() {
        if (!this.visible) return;

        if (this.acceptDelay.Running())
        {
            // already running, can't cancel now
            return;
        }

        this.visible = false;

        this.buyBonusContainer.removeChild(this.priceTextView);
        this.buyBonusContainer.removeChild(this.startTextView);

        if (this.buyBonusContainer != null) {
            this.buyBonusContainer.visible = false;
        }

        this.isLocked = false;
    }

    public IsLocked(): boolean {
        return this.isLocked;
    }


    public BetTypeSelectedCallback(callback: OnConfirmBetTypeChangePress): void {
        this.onConfirmBetTypeChangePress = callback;
    }

    public CancelSelectedCallback(callback: OnCancelBetTypeChangePress): void {
        this.onCancelBetTypeChangePress = callback;
    }

    // public ChangeBetTypeValueString(buyBonusValueString: string, buyBonusCreditsString: string): void {
    //     this.changeBetType.textContent = service.translator.t.betAndCreditsBuybonus(buyBonusValueString, buyBonusCreditsString);
    // }

    public BuyBonusPriceString(gameBet: string, buyBonusValueString: string, buyBonusCreditsString: string): void {
        //     this.changeBetType.textContent = service.translator.t.betAndCreditsBuybonus(buyBonusValueString, buyBonusCreditsString);
        this.buyBonusValueString = service.translator.t.betAndCreditsBuybonus(buyBonusValueString, buyBonusCreditsString);
        this.priceTextView = new PIXI.Text(this.buyBonusValueString, this.infoTextStyle);
        this.priceTextView.anchor.set(0.5);
        this.priceTextView.x = this.buyBonusContainer.width / 2;
        this.priceTextView.y = this.buyBonusContainer.height / 4 + Scale.fh(100); // Positioned below start text
        this.buyBonusContainer.addChild(this.priceTextView);

        this.gameBetString = gameBet;
        this.startTextView = new PIXI.Text(this.translator.t.buyStickyBonus + this.gameBetString, this.infoTextStyle);
        this.startTextView.anchor.set(0.5);
        this.startTextView.x = this.buyBonusContainer.width / 2;
        this.startTextView.y = this.buyBonusContainer.height / 4 + Scale.fh(20);
        this.buyBonusContainer.addChild(this.startTextView);
    }

}

export class BuyBonusMenuResponsive extends BuyBonusMenu
{

    public override CreatePIXIAPP(): void {

        this.buyBonusContainer = new PIXI.Container();
        //this.buyBonusContainer.width = Scale.W(1920);
        //this.buyBonusContainer.height = Scale.H(1080);
        //this.buyBonusContainer.pivot.set(Scale.W(1152) / 2, Scale.H(648) / 2);
        //this.buyBonusContainer.x = Scale.W(1920) / 2;
        // this.buyBonusContainer.y = (Settings.ScreenHeight) * (Settings.Screens - 1);
        this.buyBonusContainer.name = "buyBonusContainer";

        let spriteintroSpanishMessageContainerApp = PIXI.Sprite.from(this.textureDialogBonus);
        //spriteintroSpanishMessageContainerApp.scale.set(Scale.XY(1));
        //spriteintroSpanishMessageContainerApp.pivot.set(spriteintroSpanishMessageContainerApp.width /2 , spriteintroSpanishMessageContainerApp.height/2);  
        spriteintroSpanishMessageContainerApp.position.set(Scale.W(1920 / 2) - (spriteintroSpanishMessageContainerApp.width / 2) , 0);      
        //spriteintroSpanishMessageContainerApp.width = Scale.W(1152);
        //spriteintroSpanishMessageContainerApp.height = Scale.H(648);
        //spriteintroSpanishMessageContainerApp.tint = "0x000000";
        this.buyBonusContainer.addChild(spriteintroSpanishMessageContainerApp);

        //Create title 
        let textStyleRedTitle = new PIXI.TextStyle({
            fontFamily: 'NotoSansDisplay-Bold',
            fontSize: Scale.fh(160),
            fontWeight: 'bold',
            fill: ["red"],
            stroke: 'black',
            strokeThickness: Scale.fh(5),
            wordWrap: false,
            padding: 10,
            textBaseline: "middle",
            align: "center"
        });

        let textTitleBuyBonus = new PIXI.Text(`!${this.translator.t.buyBonusTitle}!`,textStyleRedTitle);
        this.buyBonusContainer.addChild(textTitleBuyBonus);
        textTitleBuyBonus.pivot.set(textTitleBuyBonus.width / 2 , textTitleBuyBonus.height / 2);
        textTitleBuyBonus.position.set(Scale.W(1920)/2 , Scale.H(100));
        //Finished

        this.infoTextStyle = new PIXI.TextStyle({
            fontFamily: 'NotoSansDisplay-Bold',
            fontSize: Scale.fh(80),
            fontWeight: 'bold',
            fill: "white",
            stroke: 'black',
            strokeThickness: Scale.fh(5),
            wordWrap: false,
            padding: 10,
            textBaseline: "middle",
            align: "center",
            lineJoin : "round",
        });

        this.textButtonsStyle = new PIXI.TextStyle({
            fontFamily: 'NotoSansDisplay-Bold',
            fontSize: Scale.fh(70),
            fontWeight: 'bold',
            fill: "white", // red
            stroke: 'black',
            strokeThickness: Scale.fh(5),
            wordWrap: false,
            padding: 10,
            textBaseline: "alphabetic",
            lineJoin : "round",
        });

        // this.textStyle2 = new PIXI.TextStyle({
        //     fontFamily: 'NotoSansDisplay-Bold',
        //     fontSize: Scale.fh(70),
        //     fontWeight: 'bold',
        //     fill: "white", // green
        //     stroke: 'black',
        //     strokeThickness: Scale.fh(5),
        //     wordWrap: false,
        //     padding: 10,
        //     textBaseline: "alphabetic"
        // });

        this.startTextView = new PIXI.Text(this.translator.t.buyStickyBonus + this.gameBetString, this.infoTextStyle);
        this.startTextView.anchor.set(0.5);
        this.startTextView.x = this.buyBonusContainer.width / 2;
        this.startTextView.y = this.buyBonusContainer.height / 4 + Scale.fh(20);

        this.priceTextView = new PIXI.Text(this.buyBonusValueString, this.infoTextStyle);
        this.priceTextView.anchor.set(0.5);
        this.priceTextView.x = this.buyBonusContainer.width / 2;
        this.priceTextView.y = this.startTextView.y + Scale.fh(100);

        //Create buttons 
        let buttonWidth = Scale.W(400);
        let buttonHeight = Scale.H(200);

        this.buttonAcceptContainerApp = new PIXI.Container();
        this.buttonAcceptContainerApp.name = "buttonAcceptContainerApp";
        this.buttonAcceptContainerApp.width = buttonWidth;
        this.buttonAcceptContainerApp.height = buttonHeight;
        this.buttonAcceptContainerApp.pivot.set(buttonWidth / 2, buttonHeight / 2);
        this.buttonAcceptContainerApp.x = this.buyBonusContainer.width / 2 + Scale.W(250);
        this.buttonAcceptContainerApp.y = this.priceTextView.y + Scale.H(350); // Positioned below price text
        this.buttonAcceptContainerApp.interactive = true;
        this.buyBonusContainer.addChild(this.buttonAcceptContainerApp);

        let buttonCancelContainerApp = new PIXI.Container();
        buttonCancelContainerApp.name = "buttonCancelContainerApp";
        buttonCancelContainerApp.width = buttonWidth;
        buttonCancelContainerApp.height = buttonHeight;
        buttonCancelContainerApp.pivot.set(buttonWidth / 2, buttonHeight / 2);
        buttonCancelContainerApp.x = this.buyBonusContainer.width / 2 - Scale.W(250);
        buttonCancelContainerApp.y = this.priceTextView.y + Scale.H(350); // Positioned below price text
        buttonCancelContainerApp.interactive = true;
        this.buyBonusContainer.addChild(buttonCancelContainerApp);

        let spriteButtonAcceptContainerApp = PIXI.Sprite.from(this.textureButtonBonusStart);
        spriteButtonAcceptContainerApp.width = buttonWidth;
        spriteButtonAcceptContainerApp.height = buttonHeight;
        spriteButtonAcceptContainerApp.anchor.set(0.5);
        spriteButtonAcceptContainerApp.x = buttonWidth / 2;
        spriteButtonAcceptContainerApp.y = buttonHeight / 2;
        spriteButtonAcceptContainerApp.interactive = true;

        let confirmTextView = new PIXI.Text(this.translator.t.buttonMenuAccept, this.textButtonsStyle);
        confirmTextView.anchor.set(0.5);
        confirmTextView.x = 0;
        confirmTextView.y = 0;

        spriteButtonAcceptContainerApp.addChild(confirmTextView);
        this.buttonAcceptContainerApp.addChild(spriteButtonAcceptContainerApp);

        let spriteButtonCancelContainerApp = PIXI.Sprite.from(this.textureButtonBonusEnd);
        spriteButtonCancelContainerApp.width = buttonWidth;
        spriteButtonCancelContainerApp.height = buttonHeight;
        spriteButtonCancelContainerApp.anchor.set(0.5);
        spriteButtonCancelContainerApp.x = buttonWidth / 2;
        spriteButtonCancelContainerApp.y = buttonHeight / 2;

        let cancelTextView = new PIXI.Text(this.translator.t.buttonMenuCancel, this.textButtonsStyle);
        cancelTextView.anchor.set(0.5);
        cancelTextView.x = 0;
        cancelTextView.y = 0;

        spriteButtonCancelContainerApp.addChild(cancelTextView);
        buttonCancelContainerApp.addChild(spriteButtonCancelContainerApp);

        this.buttonAcceptContainerApp.addListener("pointerdown", (ev: MouseEvent) => {           
            this.ButtonAccept();
        });

        buttonCancelContainerApp.addListener("pointerdown", (ev: MouseEvent) => {
            this.ButtonCancel();
        });

        this.buyBonusContainer.visible = false;
        this.visible = false;
        //End buttons


        //MESSAGE CONFIRM 
        let textStyleRedMessage = new PIXI.TextStyle({
            fontFamily: 'NotoSansDisplay-Bold',
            fontSize: Scale.fh(50),
            fontWeight: 'bold',
            fill: ["red"],
            stroke: 'black',
            strokeThickness: Scale.fh(5),
            wordWrap: false,
            padding: 10,
            textBaseline: "middle",
            align: "center",
            lineJoin : "round",
        });

        let textTitleBuyBonusConfirmMessage = new PIXI.Text(this.translator.t.buyStickyBonusConfirmMessage, textStyleRedMessage);
        this.buyBonusContainer.addChild(textTitleBuyBonusConfirmMessage);
        textTitleBuyBonusConfirmMessage.anchor.set(0.5)
        //textTitleBuyBonusConfirmMessage.pivot.set(textTitleBuyBonusConfirmMessage.width / 2, textTitleBuyBonusConfirmMessage.height / 2);
        textTitleBuyBonusConfirmMessage.position.set(Scale.X(1920 / 2), Scale.Y(466.5));
        

        let textStyleRedMessage2 = new PIXI.TextStyle({
            fontFamily: 'NotoSansDisplay-Bold',
            fontSize: Scale.fh(30),
            fontWeight: 'bold',
            fill: ["white"],
            stroke: 'black',
            strokeThickness: Scale.fh(5),
            wordWrap: true,
            padding: 10,
            textBaseline: "middle",
            align: "center",
            wordWrapWidth : Scale.W(1220),
            lineJoin : "round",
        });

        let textTitleBuyBonusConfirmMessage2 = new PIXI.Text(this.translator.t.buyStickyBonusConfirmMessage2, textStyleRedMessage2);
        this.buyBonusContainer.addChild(textTitleBuyBonusConfirmMessage2);
        textTitleBuyBonusConfirmMessage2.anchor.set(0.5);
        textTitleBuyBonusConfirmMessage2.position.set(Scale.X(1920 / 2), Scale.Y(547.5));
        this.translator.SetOnLanguageChangedCallback(()=>{
            textTitleBuyBonusConfirmMessage2.text = this.translator.t.buyStickyBonusConfirmMessage2;
            textTitleBuyBonusConfirmMessage.text = this.translator.t.buyStickyBonusConfirmMessage;
            textTitleBuyBonus.text = `!${this.translator.t.buyBonusTitle}!`
            //textTitleBuyBonusConfirmMessage?.pivot.set(textTitleBuyBonusConfirmMessage.width / 2, textTitleBuyBonusConfirmMessage.height / 2);
            //textTitleBuyBonusConfirmMessage?.position.set(Scale.X(1920 / 2), Scale.Y(466.5));
        });
        //END MESSAGE
    }
}